// extracted by mini-css-extract-plugin
export var bodySections = "_bn-8";
export var gray = "_bn-7";
export var green = "_bn-4";
export var iconContainer = "_bn-9";
export var iconWidgetContainer = "_bn-1";
export var phoneIcon = "_bn-2";
export var red = "_bn-5";
export var statusDot = "_bn-3";
export var widgetContainer = "_bn-0";
export var yellow = "_bn-6";